export enum AutomationsPermissions {
  GET_LISTED_AUTOMATIONS = 'automations.getListedAutomations',
  GET_AUTOMATION = 'automations.getAutomation',

  ADD_AUTOMATION = 'automations.addAutomation', // adding full automation
  EDIT_AUTOMATION = 'automations.editAutomation', // editing full automation
  DELETE_AUTOMATION = 'automations.deleteAutomation',
}
